module.exports = __webpack_public_path__ + "static/media/4_Grey_Board_02.cec4cbc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/4_Grey_Board_02.jpg
// module id = 1713
// module chunks = 0